/** Hands `blob` to the browser as a download named `name`. */
export function downloadBlob(name, blob) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = name
  a.click()
  URL.revokeObjectURL(url)
}

/**
 * Resolves once a frame has been committed, so a long call does not hide what was just rendered.
 * A hidden tab paints no frames at all: there the wait falls back to a short timer instead of
 * stalling the export until the tab is looked at again.
 */
export function nextFrame() {
  return new Promise((resolve) => {
    let settled = false
    const settle = () => {
      if (settled) return
      settled = true
      resolve()
    }
    requestAnimationFrame(() => setTimeout(settle, 0))
    setTimeout(settle, 50)
  })
}
